export const REQUEST_PERMISSION_CODES = {
    WEB_OFFICE_REQUEST_LIST: 'WEB_OFFICE_REQUEST_LIST',
    WEB_OFFICE_REQUEST_DETAIL: 'WEB_OFFICE_REQUEST_DETAIL',
    WEB_OFFICE_REQUEST_ADD: 'WEB_OFFICE_REQUEST_ADD',
    WEB_OFFICE_REQUEST_EDIT: 'WEB_OFFICE_REQUEST_EDIT',
    WEB_OFFICE_REQUEST_DELETE: 'WEB_OFFICE_REQUEST_DELETE',
    WEB_OFFICE_REQUEST_EXPORT: 'WEB_OFFICE_REQUEST_EXPORT',
} as const;

